module.exports = __webpack_public_path__ + "img/yomi_01.e6ed715d.jpg";